/*
 * @Author: liuqing
 * @Date: 2021-01-23 10:31:40
 * @LastEditors: liuqing
 * @LastEditTime: 2021-01-25 13:35:23
 * @Description: 红橙主题
 * @Copyright: © 2020 杭州杰竞科技有限公司 版权所有
 */
import React from 'react';

function BlackTheme() {
  return (
    <React.Fragment>
      <img className="black_body_bg" src={require('../../images/theme/black_body_bg.png')} alt="" />
      <img
        className='black_main_bg'
        src={require('../../images/theme/black_main_bg.png')}
        alt=''
      />
      {/* <div className="slider"></div> */}
      <div className="black__left">
        <img
          className='light__left'
          src={require('../../images/theme/black_light.png')}
          alt=''
        />
        <img
          className='dot__left'
          src={require('../../images/theme/black_left.png')}
          alt=''
        />
      </div>
      <div className="black__right">
        <img
          className='light__right'
          src={require('../../images/theme/black_light.png')}
          alt=''
        />
        <img
          className='dot__right'
          src={require('../../images/theme/black_right.png')}
          alt=''
        />
      </div>
    </React.Fragment>
  );
}

export default BlackTheme;
